export const environment = {
    version: '',
    aiConnectionString: '',
    serverBaseUrl: '',
    deviceAttachmentsBaseUrl: 'https://stkeatechassets.blob.core.windows.net/device-attachments/',
    isSupportedBrowser: true,
    mobileAppVersion: '',
    production: false,
    // Apply global settings on top of defaults
    ...settings,
};
